import { IUser } from './DataStore/IUser'

export const GET_USERS = 'GET_USERS'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE'

export const GET_CURRENT_USER = 'GET_CURRENT_USER'
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS'
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE'

export const SET_TIME_SCHEDULES = 'SET_TIME_SCHEDULES'
export const SET_TIME_SCHEDULES_SUCCESS = 'SET_TIME_SCHEDULES_SUCCESS'
export const SET_TIME_SCHEDULES_FAILURE = 'SET_TIME_SCHEDULES_FAILURE'

interface IGetUsers {
  type: typeof GET_USERS
}

interface IGetUsersSuccess {
  type: typeof GET_USERS_SUCCESS
  payload: { users: IUser[] }
}

interface IGetUsersFailure {
  type: typeof GET_USERS_FAILURE
  payload: { error: string }
}

interface IGetCurrentUser {
  type: typeof GET_CURRENT_USER
}

interface IGetCurrentUserSuccess {
  type: typeof GET_CURRENT_USER_SUCCESS
  payload: { currentUser: IUser }
}

interface IGetCurrentUserFailure {
  type: typeof GET_CURRENT_USER_FAILURE
  payload: { error: string }
}

interface ISetTimeSchedule {
  type: typeof SET_TIME_SCHEDULES
  payload: { userId: number; timeSchedules: number }
}

interface ISetTimeScheduleSuccess {
  type: typeof SET_TIME_SCHEDULES_SUCCESS
  payload: { userId: number; timeSchedules: number }
}

interface ISetTimeScheduleFailure {
  type: typeof SET_TIME_SCHEDULES_FAILURE
  payload: { error: string }
}

export type TActionTypes =
  | IGetUsers
  | IGetUsersSuccess
  | IGetUsersFailure
  | IGetCurrentUser
  | IGetCurrentUserSuccess
  | IGetCurrentUserFailure
  | ISetTimeSchedule
  | ISetTimeScheduleSuccess
  | ISetTimeScheduleFailure
